import { render } from "./update_notification.vue?vue&type=template&id=653a2178"
import script from "./update_notification.js?vue&type=script&lang=js"
export * from "./update_notification.js?vue&type=script&lang=js"

import "./update_notification.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__